export const crowdAgeOption = [
  { name: "Adult" },
  { name: "Old" },
  { name: "Teenage" },
  { name: "Kid" },
];

export const crowdTypeOption = [{ name: "Male" }, { name: "Female" }];
